<template>
    <div class="row py-2" v-if="hasOrderNumber || hasOrderDate">
        <div class="col overview-container" v-if="hasOrderNumber">
            <div v-if="customerName || consumerNameC2p" class="overview-customer-name" tabindex="0">
                <p class="overview-paragraph" v-text="$ml.get('customerName')" />
                <b v-if="isClick2PayPayment">{{ consumerNameC2p }}</b>
                <b v-else>{{ customerName }}</b>
            </div>
            <div class="overview-order-id" tabindex="0">
                <p class="overview-paragraph" v-text="$ml.get('orderNumber')" />
                <b>{{ orderNumber }}</b>
            </div>
            <div v-if="customerFirstDigits || consumerFirstDigitsC2p" class="overview-first-digits">
                <p class="overview-paragraph" v-text="$ml.get('documentNumber')" tabindex="0" />
                <div v-if="$ml.current === 'pt-br'" tabindex="0">
                    <b v-if="isClick2PayPayment">{{ consumerFirstDigitsC2p
                    }}<span>.&bull;&bull;&bull;.&bull;&bull;&bull;-&bull;&bull;</span></b>
                    <b v-else>{{ customerFirstDigits
                    }}<span>.&bull;&bull;&bull;.&bull;&bull;&bull;-&bull;&bull;</span></b>
                </div>
                <div v-else tabindex="0">
                    <b><span>&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;</span></b>
                </div>
            </div>
            <div class="overview-order-date" v-if="hasOrderDate" tabindex="0">
                <p class="overview-paragraph" v-text="$ml.get('orderDate')" />
                <b>{{ localizeOrderDate(orderDate, $ml.current) }}</b>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters({
			customerFirstDigits: 'customer/getCustomerFirstDigits',
			customerName: 'customer/getCustomerName',
			orderNumber: 'preorder/getOrderNumber',
			orderDate: 'preorder/getOrderDate',
			consumerFirstDigitsC2p: 'clickToPayPayment/getConsumerFirstDigitsC2p',
			consumerNameC2p: 'clickToPayPayment/getConsumerName',
		}),

		hasOrderNumber: self => !!self.orderNumber,
		hasOrderDate: self => !!self.orderDate,

		isClick2PayPayment: (self) => self.$store.state.payment.PaymentType === 100,
	},
	methods: {
		localizeOrderDate(orderDate, currentLocale) {
			const pattern = /(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})/;
			let date = new Date(
				orderDate.replace(pattern, '$3-$2-$1T$4:$5:$6Z')
			);

			return date.toLocaleString(currentLocale, {
				timeZone: 'UTC',
				dateStyle: 'medium',
				timeStyle: 'medium'
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.overview-container {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 100%;
	gap: 8px;
	color: #2f363e;
}

.overview-order-id {
	font-size: 14px;
	width: 100%;
}

.overview-paragraph {
	margin-bottom: 4px;
	font-size: 14px;
}
</style>
